import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapAssignedLocationSummaryPage } from '../checkInLocation.mapper';
import type {
  LC_AssignedLocationSummaryOut,
  AssignedLocationSummaryListParams,
  AssignedLocationSummaryPage,
} from '../checkInLocation.types';


export class LocationAssignedSummaryService {
  async list(
    params: AssignedLocationSummaryListParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<AssignedLocationSummaryPage>> {
    const queryString = buildQueryString({
      page: params.page,
      pageSize: params.pageSize,
      searchText: params.searchText ?? undefined,
      orderBy: params.sort?.key,
      orderDirection: params.sort?.direction?.toUpperCase(),
      locationId: params.locationId,
      employeeId: params.employeeId,
    });

    const response = await apiClient.get<LC_AssignedLocationSummaryOut>(
      `${API_CONFIG.ENDPOINTS.CHECK_IN_LOCATION.ASSIGNED_EMPLOYEES}${queryString}`,
      { signal },
    );

    if (response.success && response.data) {
      return { success: true, data: mapAssignedLocationSummaryPage(response.data) };
    }

    return { success: false, data: null, error: response.error, status: response.status };
  }

  async download(
    params?: { locationId?: number; employeeId?: number },
  ): Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    const queryString = buildQueryString({
      locationId: params?.locationId,
      targetEmployeeId: params?.employeeId,
    });
    const response = await apiClient.downloadBlobWithFilename(
      `${API_CONFIG.ENDPOINTS.CHECK_IN_LOCATION.ASSIGNED_EMPLOYEES_EXPORT}${queryString}`,
      { method: 'GET' },
    );

    if (response.success && response.data) {
      return response;
    }

    return { ...response, data: null };
  }
}

export const locationAssignedSummaryService = new LocationAssignedSummaryService();
